import React from "react";
import useConstrainable from "../hooks/use-constrainable";

export default function SetInitialConstraints({constraints = null}) {

    const constrainable = useConstrainable();

    React.useEffect(() => {
        if (typeof constraints === 'object' && !!constraints) {
            const keys = Object.keys(constraints);
            if (keys.length > 0) {
                keys.forEach(key => {
                    constrainable.setConstraint(key, constraints[key], false);
                })
            }
        }
    }, [])

    return null;
}
